import React from "react";

interface VideoPlayerProps {
  src: string;
  poster?: string;
  width?: number;
  height?: number;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, poster, width = 800, height = 450 }) => {
  return (
    <div className="flex justify-center items-center w-full">
      <video
        controls
        width={width}
        height={height}
        poster={poster}
        className="rounded-lg shadow-md max-w-full"
      >
        <source src={src} type="video/mp4" />
        Tarayıcınız video etiketini desteklemiyor.
      </video>
    </div>
  );
};

export default VideoPlayer;
